import * as yup from 'yup';
import { getBudgetData, getBudgetPdfURL } from './model';
import message from '../../message';
import { ToastNotification } from '../../ToastNotification';
import { handleErrorMessage } from '../../handleErrorMessage';

export const getBudgetDataController = async (budgetId: string) => {
  try {
    await yup.string().required().validate(budgetId);
    const res = await getBudgetData(budgetId);
    return res;
  } catch (error) {
    if (error instanceof yup.ValidationError) {
      message(error.errors[0], 'warning');
    }
    message(error, 'error');
  }
};

export const getBudgetPdfURLController = async (orderServiceId: string) => {
  try {
    const res = await getBudgetPdfURL(orderServiceId);
    return res;
  } catch (error) {
    ToastNotification.show(handleErrorMessage(error), 'error');
  }
};
